import type { PapelObraFormDialogProps } from "./types-papel-obra-form-dialog";
import { usePapelObraFormDialog } from "./use-papel-obra-form-dialog";
import { PapelObraFormDialogView } from "./view-papel-obra-form-dialog";

/** Formulário "Novo papel" e "Editar papel" (HU 2034 e 2035). */
export function PapelObraFormDialog(props: PapelObraFormDialogProps) {
  const vm = usePapelObraFormDialog(props);

  return <PapelObraFormDialogView {...vm} />;
}

export type * from "./types-papel-obra-form-dialog";
